export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Clé API',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
  },
  connected: {
    title: 'ExpertOrder est connecté',
    description: 'Cette intégration est configurée.',
  },
};
